import {
  api, getOptions,
} from './helpers';

const getBookStatistics = (payload) => api.post('/statistics/bookStatistics', payload, getOptions());

export default {
  getBookStatistics,
};
